
export default {
  props: {
    product: Object,
    productIsHover: Boolean,
    prioritizeVariantImage: {
      default: false,
      type: Boolean,
    },
    isLcpImage: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      secondImageLoaded: false,
    }
  },
  computed: {
    primaryImage() {
      if (this.product.images?.length && !this.prioritizeVariantImage) {
        return this.product.images[0]
      }
      if (this.product.variant.images?.length) {
        return this.product.variant.images[0]
      }
      return null
    },
    secondaryImage() {
      if (!this.product.display_second_image) return null
      if (this.product.images?.length && !this.prioritizeVariantImage) {
        return this.product.images.length > 1
          ? this.product.images[1]
          : this.product.variant?.images?.[0] || null
      }
      if (
        this.product.variant.images?.length > 1 &&
        !this.product.images?.length
      ) {
        return this.product.variant.images[1]
      }
      return null
    },
    hasImages() {
      return !!this.primaryImage?.url
    },
    hasSecondImage() {
      return (
        !!this.secondaryImage?.url &&
        this.secondaryImage?.url !== this.primaryImage?.url
      )
    },
    showSecondImage() {
      return this.productIsHover && this.hasSecondImage
    },
    primaryExtension() {
      return this.primaryImage?.extension || 'jpg'
    },
    secondaryExtension() {
      return this.secondaryImage?.extension || 'jpg'
    },
    imageDimension() {
      return this.$device.isMobile ? 160 : 280
    },
    primarySrc() {
      return this.$cropUrl(
        this.primaryImage,
        this.imageDimension,
        this.imageDimension,
        this.primaryExtension,
        80
      )
    },
    primarySrcset() {
      return this.getSrcset(
        this.primaryImage,
        this.imageDimension,
        this.primaryExtension
      )
    },
    secondarySrc() {
      return this.$cropUrl(
        this.secondaryImage,
        this.imageDimension,
        this.imageDimension,
        this.secondaryExtension,
        80
      )
    },
    secondarySrcset() {
      return this.getSrcset(
        this.secondaryImage,
        this.imageDimension,
        this.secondaryExtension
      )
    },
    productName() {
      return this.product.name
    },
    imageClass() {
      return this.$device.isMobile ? 'mr-2 tw-h-auto w-100' : ''
    },
    imageLoading() {
      return this.isLcpImage ? 'eager' : 'lazy'
    },
    imageFetchPriority() {
      return this.isLcpImage ? 'high' : 'low'
    },
  },
  watch: {
    productIsHover(isHover) {
      if (isHover && this.hasSecondImage && !this.secondImageLoaded) {
        this.secondImageLoaded = true
      }
    },
  },
  methods: {
    getSrcset(image, size, extension) {
      return `${this.$cropUrl(image, size * 2, size * 2, extension, 80)} 2x`
    },
  },
}
